<template>
  <layout>
    <div slot="content">
      <i-card title="供应商管理">
        <div slot="content">
          <div class="toolbar">
            <el-input
              v-model="keyword"
              placeholder="搜索名称/负责人/电话"
              size="small"
              style="width: 240px; margin-right: 10px"
              clearable
              @keyup.enter.native="loadList"
            />
            <el-button size="small" type="primary" @click="loadList">搜索</el-button>
            <el-button size="small" type="success" @click="openDialog()">+ 新增供应商</el-button>
          </div>

          <el-table :data="list" v-loading="loading" border style="width: 100%; margin-top: 15px">
            <el-table-column prop="id" label="ID" width="70" />
            <el-table-column prop="name" label="供应商名称" min-width="160" />
            <el-table-column prop="contact_name" label="负责人" width="120" />
            <el-table-column prop="phone" label="联系电话" width="140" />
            <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip />
            <el-table-column prop="created_at" label="创建时间" width="170" />
            <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click="openDialog(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrap">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="onPageChange"
            />
          </div>
        </div>
      </i-card>

      <!-- 新增 / 编辑弹窗 -->
      <el-dialog
        :title="form.id ? '编辑供应商' : '新增供应商'"
        :visible.sync="dialogVisible"
        width="520px"
        :close-on-click-modal="false"
        @closed="resetForm"
      >
        <el-form :model="form" :rules="rules" ref="supplierForm" label-width="100px" size="small">
          <el-form-item label="供应商名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入供应商名称" />
          </el-form-item>
          <el-form-item label="负责人">
            <el-input v-model="form.contact_name" placeholder="请输入负责人姓名" />
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="form.phone" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="form.address" type="textarea" :rows="3" placeholder="请输入地址" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="saving" @click="handleSave">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout'
import iCard from '@/components/i-card'

export default {
  name: 'supplier-list',
  components: { layout, iCard },
  data() {
    return {
      loading: false,
      list: [],
      keyword: '',
      total: 0,
      pageSize: 15,
      currentPage: 1,
      dialogVisible: false,
      saving: false,
      form: {
        id: null,
        name: '',
        contact_name: '',
        phone: '',
        address: '',
      },
      rules: {
        name: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
      },
    }
  },
  methods: {
    loadList() {
      this.loading = true
      this.$http.request('supplierList', {
        keyword: this.keyword,
        page: this.currentPage,
      }).then(res => {
        this.loading = false
        if (res && res.data) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
          this.pageSize = res.data.per_page || 15
        }
      }).catch(() => {
        this.loading = false
      })
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          name: row.name || '',
          contact_name: row.contact_name || '',
          phone: row.phone || '',
          address: row.address || '',
        }
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.form = { id: null, name: '', contact_name: '', phone: '', address: '' }
      this.$refs.supplierForm && this.$refs.supplierForm.clearValidate()
    },
    handleSave() {
      this.$refs.supplierForm.validate(valid => {
        if (!valid) return
        this.saving = true
        const api = this.form.id ? 'editSupplier' : 'addSupplier'
        this.$http.request(api, this.form).then(res => {
          this.saving = false
          if (res) {
            this.$message.success(this.form.id ? '编辑成功' : '新增成功')
            this.dialogVisible = false
            this.loadList()
          }
        }).catch(() => {
          this.saving = false
        })
      })
    },
    handleDel(row) {
      this.$confirm(`确定要删除供应商「${row.name}」吗？`, '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.request('delSupplier', { id: row.id }).then(res => {
          if (res && res.status === 'success') {
            this.$message.success('删除成功')
            this.loadList()
          }
        })
      }).catch(() => {})
    },
    onPageChange(page) {
      this.currentPage = page
      this.loadList()
    },
  },
  created() {
    this.loadList()
  },
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.pagination-wrap {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplier/supplier-list.vue